// extracted by mini-css-extract-plugin
export default {"flexiLoanEligibleContainer":"ApplyFlexiLoanInfoView_flexiLoanEligibleContainer"};